import { bool, array, func } from "prop-types"
import { Select } from "components/ui"
import { Box, StackView } from "@planningcenter/tapestry-react"
import { HelperShelfMessage, HelperShelfTrigger } from "components/helper_shelf"
import Icon from "components/planning_center_icon"
import pcoUrl from "@planningcenter/url"

const Campuses = ({ isEditing, campuses, selectedCampuses, onCampusChange }) => {
  const handleAdd = ({ target: { value: campusId } }) => {
    let campusesToChange = []

    if (selectedCampuses.find(sc => sc.id === campusId)) {
      campusesToChange = selectedCampuses.map(sc =>
        sc.id === campusId ? { ...sc, action: null } : sc
      )
    } else {
      const campus = campuses.find(c => c.id === campusId)
      campusesToChange = [
        ...selectedCampuses,
        { id: campus.id, name: campus.attributes.name, action: "add_campus" }
      ]
    }

    onCampusChange(campusesToChange)
  }

  const handleRemove = campusId => {
    let campusesToChange = []
    const campus = selectedCampuses.find(sc => sc.id === campusId)

    if (campus.action === null) {
      campusesToChange = selectedCampuses.map(sc =>
        sc.id === campusId ? { ...sc, action: "remove_campus" } : sc
      )
    } else if (campus.action === "add_campus") {
      campusesToChange = selectedCampuses.filter(sc => sc.id !== campusId)
    }

    onCampusChange(campusesToChange)
  }

  const campusSelectOptions = campuses.filter(
    c => !selectedCampuses.filter(sc => sc.action !== "remove_campus").find(sc => sc.id === c.id)
  )

  const campusLink = `${pcoUrl(window.railsEnv)("accounts")}/organization/campuses`

  return (
    <div>
      <StackView
        axis="horizontal"
        alignment="center"
        distribution="space-between"
        marginRight={0}
        position="relative"
        marginBottom={0.5}
        css={{ minHeight: 24 }}
      >
        <div className="d-f jc-sb ai-c w-100%">
          <div className="d-f ai-c">
            <label htmlFor="detail-campus" className="mb-0">
              Campuses
            </label>
            {isEditing && (
              <span className="ml-4p p-r t-1p font-size-4">
                <HelperShelfTrigger id="campus" />
              </span>
            )}
          </div>
          <a href={campusLink}>
            <button className="btn-ghost xs">Manage campuses</button>
          </a>
        </div>
      </StackView>
      <HelperShelfMessage id="campus">
        <p>
          These are the campuses used throughout Planning Center. You can manage them from your
          organization&apos;s <a href={campusLink}>account settings</a>.
        </p>
      </HelperShelfMessage>
      <div>
        <div>
          {isEditing && (
            <div
              className="mb-1"
              style={{
                display: campusSelectOptions.length < 1 ? "none" : null
              }}
            >
              <Select
                id="campus-select"
                name="campuses"
                onChange={handleAdd}
                options={[
                  { value: "", label: "Select a campus" },
                  ...campusSelectOptions.map(c => ({
                    value: c.id,
                    label: c.attributes.name
                  }))
                ]}
              />
            </div>
          )}
          {campuses.length > 0 ? (
            <div className="option__list">
              <ul className="action-list my-0">
                {selectedCampuses.length > 0 ? (
                  <>
                    {selectedCampuses
                      .filter(sc => sc.action !== "remove_campus")
                      .map(sc => {
                        return (
                          <li className="d-f jc-sb action-list__item" key={sc.id}>
                            <div className="p-1">{sc.name}</div>
                            {isEditing && (
                              <button
                                className="action-list-item__remove"
                                onClick={() => handleRemove(sc.id)}
                                aria-label="Remove this campus from this signup"
                              >
                                <span className="p-r t-2p">
                                  <Icon
                                    symbol="general#x"
                                    title={`Remove the ${sc.name} association from this signup.`}
                                  />
                                </span>
                              </button>
                            )}
                          </li>
                        )
                      })}
                  </>
                ) : (
                  <li className="d-f jc-sb action-list__item">
                    <div className="p-1">No campuses selected.</div>
                  </li>
                )}
              </ul>
            </div>
          ) : (
            <Box marginBottom={1} padding={1} className="action-list__item">
              You don&apos;t have any campuses yet.
            </Box>
          )}
        </div>
      </div>
    </div>
  )
}

Campuses.propTypes = {
  isEditing: bool,
  campuses: array,
  selectedCampuses: array,
  onCampusChange: func
}

export default Campuses
